// extracted by mini-css-extract-plugin
export default {"title":"IGXspw36LhpxR1ykYOlk","stepper":"Gs2S9ZQB9NiraPQCdyi2"};